import { InventoryDTO } from "../DTO/inventoryDTO";

export class StoreInventoryRequest{
    public userId!:string;
    public businessId!:string;
    public inventory!:InventoryDTO;
}